<div class="frequency-wrapper" [class.disabled]="disabled">
  @if (!isMonthlyDelivery) {
  <div class="controls-container">
    <mat-button-toggle-group
      [(ngModel)]="frequency"
      name="frequency"
      [hideSingleSelectionIndicator]="true"
      (change)="onFrequencyChange($event)"
    >
      <mat-button-toggle
        id="weekly-frequency"
        value="WEEKLY"
        class="toggle-option"
        >Weekly</mat-button-toggle
      >
      <mat-button-toggle
        id="bi-weekly-frequency"
        value="BI_WEEKLY"
        class="toggle-option"
        >Bi-Weekly</mat-button-toggle
      >
    </mat-button-toggle-group>
    <mat-divider vertical class="vertical-divider"></mat-divider>
    <div class="day-circle-group">
      @for (day of days; track day) {
      <button
        type="button"
        class="day-circle"
        id="day-frequency"
        [disabled]="disabled"
        [class.selected]="selectedDays.includes(day.value)"
        (click)="toggleDay(day.value)"
      >
        {{ day.label }}
      </button>
      }
    </div>
  </div>
  } @if (this.isMonthlyDelivery) {
  <div>
    <div class="monthly-delivery-wrapper">
      <span>Monthly Delivery</span>
      <mat-icon class="material-icons-outlined">lock</mat-icon>
    </div>
  </div>
  }
</div>
